import { Converter } from '../types/converter';

export const electrostaticCapacitanceConverter: Converter = {
  id: 'electrostaticCapacitance',
  name: 'Electrostatic Capacitance Converter',
  icon: 'Battery',
  categories: ['electricity'],
  units: [
    // Base SI unit and prefixes
    { name: 'Farad', symbol: 'F', factor: 1 },
    { name: 'Exafarad', symbol: 'EF', factor: 1e18 },
    { name: 'Petafarad', symbol: 'PF', factor: 1e15 },
    { name: 'Terafarad', symbol: 'TF', factor: 1e12 },
    { name: 'Gigafarad', symbol: 'GF', factor: 1e9 },
    { name: 'Megafarad', symbol: 'MF', factor: 1e6 },
    { name: 'Kilofarad', symbol: 'kF', factor: 1e3 },
    { name: 'Hectofarad', symbol: 'hF', factor: 1e2 },
    { name: 'Dekafarad', symbol: 'daF', factor: 10 },
    { name: 'Decifarad', symbol: 'dF', factor: 0.1 },
    { name: 'Centifarad', symbol: 'cF', factor: 0.01 },
    { name: 'Millifarad', symbol: 'mF', factor: 1e-3 },
    { name: 'Microfarad', symbol: 'µF', factor: 1e-6 },
    { name: 'Nanofarad', symbol: 'nF', factor: 1e-9 },
    { name: 'Picofarad', symbol: 'pF', factor: 1e-12 },
    { name: 'Femtofarad', symbol: 'fF', factor: 1e-15 },
    { name: 'Attofarad', symbol: 'aF', factor: 1e-18 },
    
    // Alternative expressions
    { name: 'Coulomb/volt', symbol: 'C/V', factor: 1 },
    
    // CGS units
    { name: 'Abfarad', symbol: 'abF', factor: 1e9 },
    { name: 'EMU of capacitance', symbol: 'EMU', factor: 1e9 },
    { name: 'Statfarad', symbol: 'stF', factor: 1.112650e-12 },
    { name: 'ESU of capacitance', symbol: 'ESU', factor: 1.112650e-12 }
  ]
};
